import React, { useState, useEffect } from 'react';
import { Link as ScrollLink } from 'react-scroll';
import { useLanguage } from '../../contexts/LanguageContext';

const PrivacyPolicyNav = () => {
  const { t } = useLanguage();
  const [activeSection, setActiveSection] = useState('overview');

  const navItems = [
    { id: 'overview', label: t('privacy.nav.overview') },
    { id: 'hosting', label: t('privacy.nav.hosting') },
    { id: 'general-info', label: t('privacy.nav.generalInfo') },
    { id: 'data-collection', label: t('privacy.nav.dataCollection') },
    { id: 'social-media', label: t('privacy.nav.socialMedia') },
    { id: 'newsletter', label: t('privacy.nav.newsletter') },
    { id: 'plugins-tools', label: t('privacy.nav.pluginsTools') },
  ];

  // Track active section on scroll
  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('.st-privacy-section');
      const scrollPos = window.scrollY + 150;

      sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.offsetHeight;
        const sectionId = section.getAttribute('id');

        if (scrollPos >= sectionTop && scrollPos < sectionTop + sectionHeight) {
          setActiveSection(sectionId);
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className="st-privacy-nav st-sticky">
      <h3 className="st-privacy-nav-title">{t('privacy.nav.title')}</h3>
      <ul className="st-privacy-nav-list">
        {navItems.map((item) => (
          <li key={item.id}>
            <ScrollLink
              to={item.id}
              spy={true}
              smooth={true}
              offset={-100}
              duration={500}
              className={activeSection === item.id ? 'active' : ''}
              onSetActive={() => setActiveSection(item.id)}
            >
              {item.label}
            </ScrollLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default PrivacyPolicyNav;
